<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Authors</template>

    <Sheet.Body>
      <EntityListBody
        subtitle="Authors of this registered work"
        :entities="entities"
        :loading="loading"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'
import EntityListBody from './EntityListBody.vue'
import { useAllAuthors } from './useAllEntities'

const props = defineProps<{
  file: CopyrightFile
}>()

const { close } = useSheet()
const { entities, loading } = useAllAuthors(props.file)
</script>
